import type { QueryClient } from '@tanstack/react-query';
import { authKeys, authMeQueryOptions } from '../api/queries';
import type { SessionData } from '@entities/session';
import { ApiError } from '@shared/api/errors';

/** Recheck uncertain host authentication before using either requester authority. */
export function moveHostIdentity(queryClient: QueryClient, mountedAccountId?: string) {
  return async (): Promise<'account' | 'guest'> => {
    const state = queryClient.getQueryState(authKeys.me());
    const session =
      state?.status === 'success' && state.fetchStatus === 'idle'
        ? queryClient.getQueryData<SessionData | null>(authKeys.me())
        : await queryClient.fetchQuery({ ...authMeQueryOptions(), staleTime: 0 });
    if ((session?.user?.id ?? undefined) !== mountedAccountId) {
      throw new ApiError({ message: 'Move identity changed', status: 0, code: 'ABORTED' });
    }
    return session?.user ? 'account' : 'guest';
  };
}
